export default __webpack_public_path__ + "static/media/9.blur.dfd65d0d.jpeg";